import { Component } from '@angular/core';
import { DataExchangeService } from '../../../../service/dataexchange.service';

@Component({
  selector: 'ch-sidenav-btn',
  templateUrl: './sidenav-btn.component.html'
})
export class SidenavBtnComponent {

  constructor(private readonly dataExchangeService: DataExchangeService) { }

  clickOpenSidenav() {
    this.dataExchangeService.setChangeSidenavStatus(true);
  }
}
